import React from "react";
import VoiceScreen from "../components/VoiceScreen";

const VoiceScreenPage = () => {
  return <VoiceScreen />;
};

export default VoiceScreenPage;
